import React from 'react';
import { TypeList, TypeListItem, spacer8, Type } from '@spotify-internal/encore-web';

import { DocumentLink } from 'lib/sanity/types';
import { useTranslation } from 'providers/translations/TranslationProvider';
import { ArticleLink } from 'components/Links';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

export interface RelatedArticlesProps {
  relatedArticles?: DocumentLink[];
  ubi: UbiArticlePage;
}

const RelatedArticles = ({ relatedArticles = [], ubi }: RelatedArticlesProps) => {
  const { t } = useTranslation();

  if (!relatedArticles.length) return null;

  return (
    <>
      <Type as="h2" variant="cello" paddingBottom={spacer8}>
        {t('related_articles')}
      </Type>
      <TypeList condensedAll listStyleReset>
        {relatedArticles.map((relatedArticle, index) => (
          <TypeListItem key={relatedArticle.slug} variant="ballad" condensed listStyleReset>
            <ArticleLink
              slug={relatedArticle.slug}
              semanticColor="textBrightAccent"
              queryParams={{ ref: 'related' }}
              eventDefinition={{
                category: 'related_articles',
                action: 'click_related_article',
                label: relatedArticle.slug,
              }}
              ubiFactory={ubi.logRelatedArticle(relatedArticle.slug, index)}
            >
              {relatedArticle.title}
            </ArticleLink>
          </TypeListItem>
        ))}
      </TypeList>
    </>
  );
};

export default RelatedArticles;
